export default function maInputArray() {
    return {
        scope: {
            item: '='
        },
        link: function (scope, element) {
            let controller = scope.$parent;

            scope.isOpen = function () {
                return controller.isParentActive(scope.item);
            };
            scope.toggle = function () {
                scope.$root.toggle_open = (scope.$root.toggle_open === scope.item ? null : scope.item);
            };

        },
        template: `
            <md-button class="md-button-toggle" ng-click="toggle()"
                aria-expanded="true">
                <span aria-hidden="true" class="pull-right caret" ng-class="{'toggled' : isOpen()}"></span>
                <span ng-bind-html="item._icon"></span>
                {{item._title | translate}}
            </md-button>
            <ul ng-show="isOpen()" id="docs-menu-{{item._title | nospace}}" class="menu-toggle-list">
                <li ng-repeat="subitem in item._children">
                    <menu-link item="subitem"></menu-link>
                </li>
            </ul>
        `
    };
};

maInputArray.$inject = [];


/** WEBPACK FOOTER **
 ** ./js/directives/menu_toggle.js
 **/